.dashboard-link {
    text-align: center;
}

.dashboard-link a {
    cursor: pointer;
}

.dashboard-tab-container {
    padding: 0px;
}

.dashboard-tab {
    border: 0px;
    border-radius: 4px 4px 0px 0px;
    margin-right: 1px;
    font-size: 13px;
    line-height: 25px;
    margin-top: 5px;
}

.dashboard-tab.active {
    margin-top: 0px;
    line-height: 30px;
}

.icon-postgres:before {
    height: 43px;
    margin-top: 13px;
    display: block;
}

/* CSS to make subnode control look pretty - START */
.dashboard-tab-container .subnode-dialog .form-control {
    font-size: inherit;
}

#server_activity .CodeMirror,
#database_activity .CodeMirror,
#server_activity .CodeMirror-scroll,
#database_activity .CodeMirror-scroll {
    height: auto;
    max-height:100px;
}

.dashboard-hidden {
  display: none;
}
